/* eslint-disable */
import axios from "@/axios";
import store from "@/store";

export function getCurrentUser({ agencyId }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  if (agencyId) {
    headers['x-agency-id'] = agencyId;
  }

  return axios.get("/users/me", { headers });
}

export function updateCurrentUser({ payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.put("/users/me", payload, { headers });
}

export function createCurrentUser([ payload ]) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.post("/users/me", payload, { headers });
}

export function getUsers({ params, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get("/users", { headers, param, signal });
}

export function createUser({ payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.post("/users", payload, { headers });
}

export function getUser({ userId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/users/${userId}`, { headers, signal });
}

export function updateUser({ userId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.put(`/users/${userId}`, payload, { headers });
}

export function deleteUser({ userId, params }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.delete(`/users/${userId}`, { headers, params });
}

export function getUsersAssignedToAgency({ agencyId, params, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.get(`/agencies/${agencyId}/users`, { headers, params, signal });
}

export function addUserToAgency({ agencyId, userId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.put(`/agencies/${agencyId}/users/${userId}`, payload, { headers });
}

export function removeUserFromAgency({ agencyId, userId }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.delete(`/agencies/${agencyId}/users/${userId}`, { headers });
}

export function linkUserIdentity({ userId, childId }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  
  return axios.post(`/users/${userId}/link/${childId}`, {}, { headers });
}
